import React, { forwardRef } from 'react';

import styles from './Step.scss';

export type StepProps = {
  description: string;
  image: {
    alt: string;
    avif: string;
    height: number;
    jpg: string;
    webp: string;
    width: number;
  };
  title: string;
};

export const Step = forwardRef<HTMLDivElement, StepProps>(({ description, image, title }, ref) => (
  <div ref={ref} className={styles.component} data-testid='howItWorksStep'>
    <picture>
      <source srcSet={image.avif} type="image/avif" />
      <source srcSet={image.webp} type="image/webp" />
      <img alt={image.alt} height={image.height} loading="lazy" src={image.jpg} width={image.width} />
    </picture>
    <div className={styles.content}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
));
